import { render, staticRenderFns } from "./respuestasGestionDetalle.vue?vue&type=template&id=7a968690"
import script from "./respuestasGestionDetalle.vue?vue&type=script&lang=js"
export * from "./respuestasGestionDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports